import React, {Component, Fragment} from 'react';
import '../../local_node_modules/react-select/dist/react-select.css';
import Alert from "react-s-alert";
import {Alert as Alert2, Col, Row} from 'reactstrap';
import Select from "../../local_node_modules/react-select"
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import {isValidPayTrOrder} from "../../common/componentValidation";
import DefaultModal from "../invoice/DefaultModal";
import {Accordion, AccordionItem, AccordionItemBody, AccordionItemTitle,} from 'react-accessible-accordion';
import {request} from "../../helper/APIUtils";
import {Decimal} from 'decimal.js';
import {defterUnitName, defterUnitNameShort, show100000AsUnlimited} from "../../helper/permission";
import {EntegratorConf, VirtualHost} from "../../constants";
import ReactLoading from "react-loading";
import moment from "moment/moment";
import {CopyToClipboard} from "react-copy-to-clipboard";

class PayTrModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            prices: [],
            error: {},
            payTrOrder: {payTrOrderLines: []},
            payTrOrderList: [],
            kontorYear:1,
            alanYear:1,
            saveLoading: false,
            unlimited: show100000AsUnlimited(this.props.parentCustomerId),
            couponCode: undefined,
            acceptMbt24Coupon: false,
            isCreditUser: props.isCreditUser,
            isAreaUser: props.isAreaUser
        };

        this.getList = this.getList.bind(this);
        this.onChange = this.onChange.bind(this);
        this.save = this.save.bind(this);
        this.removePayTrOrderLine = this.removePayTrOrderLine.bind(this);
        this.addPayTrOrderLine = this.addPayTrOrderLine.bind(this);
        this.acceptCoupon = this.acceptCoupon.bind(this);
    }

    componentWillMount() {
        this.getList();
    }

    getList() {
        this.setState({modal: this.props.modal});
        let self = this;
        let kontorYearParams = {
            url: `/payTrOrder/getExpireYearFromUnit/${self.props.parentCustomerId}`,
            method: "post"
        };
        request(kontorYearParams)
            .then((response) => {
                if (response && response.data) {
                    const data = response.data;
                    if (data instanceof Array) {
                        for (let d = 0; d < data.length; d++) {
                            switch (data[d].unit) {
                                case 1:
                                    self.setState({kontorYear: data[d].expireYear});
                                    break;
                                case 2:
                                    self.setState({alanYear: data[d].expireYear});
                                    break;
                            }
                        }
                    }
                }
            }).catch((err) => {
                self.setState({kontorYear: 1, alanYear: 1});
        });

        let params = {
            url: "/payTrOrder/getPayTrOrderList",
            method: "post"
        };
        self.setState({loading: true});
        request(params)
            .then(function (response) {
                let initPriceList = response.data.prices.filter(price => price[2] === 1);
                let initPriceMbList = response.data.prices.filter(price => price[2] === 2);

                let initPrice = initPriceList[0];
                let initPriceMb = initPriceMbList[0];
                if (self.state.isCreditUser === false && self.state.isAreaUser === true) {
                    self.setState({
                        payTrOrder: {
                            payTrOrderLines: [{
                                recordId: null,
                                unit: 2,
                                count: initPriceMb[0],
                                price: initPriceMb[1]
                            }]
                        },
                        initPrice,
                        initPriceMb,
                        payTrOrderList: response.data.list,
                        prices: response.data.prices
                    });
                } else {
                    self.setState({
                        payTrOrder: {
                            payTrOrderLines: [{
                                recordId: null,
                                unit: 1,
                                count: initPrice[0],
                                price: initPrice[1]
                            }]
                        },
                        initPrice,
                        initPriceMb,
                        payTrOrderList: response.data.list,
                        prices: response.data.prices
                    });
                }
            }).catch(function (error) {
            showAxiosError(error);
        }).then(function () {
            self.setState({loading: false});
        });
    }

    removePayTrOrderLine(index) {
        let payTrOrder = deepCopyObject(this.state.payTrOrder);
        payTrOrder.payTrOrderLines.splice(index, 1);
        this.setState({payTrOrder});
    }

    copied(paymentLink) {
        if (paymentLink) {
            Alert.success("RefNo kopyalandı.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000,
                html: false
            });
        }
    }

    addPayTrOrderLine() {
        let payTrOrder = deepCopyObject(this.state.payTrOrder);
        if (this.state.initPrice !== undefined) {
            payTrOrder.payTrOrderLines.push(
                {
                    recordId: null,
                    unit: this.state.isCreditUser === false && this.state.isAreaUser === true ? 2 : 1,
                    count: this.state.initPrice[0],
                    price: this.state.initPrice[1]
                }
            );
        }
        this.setState({payTrOrder});
    }

    save(e) {
        e.preventDefault();
        let payTrOrder = deepCopyObject(this.state.payTrOrder);
        payTrOrder.merchantFailUrl = window.location.origin;
        payTrOrder.merchantOkUrl = window.location.origin;
        payTrOrder.couponCode = this.state.acceptMbt24Coupon ? "mbt24" : null;
        payTrOrder.paymentType = "CUSTOMER_PAYMENT";
        let result = isValidPayTrOrder(payTrOrder);
        let valid = result.valid;
        if (valid) {
            let self = this;
            let params = {
                url: "/payTrOrder/save",
                method: "post",
                data: payTrOrder
            };
            self.setState({saveLoading: true});
            request(params)
                .then(function (response) {
                    let order = response.data;
                    Alert.success("Sepete eklendi.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 2000,
                        html: false
                    });
                    self.setState({
                        payTrOrder: {
                            payTrOrderLines: [{
                                recordId: null,
                                unit: 1,
                                count: 100,
                                price: 100
                            }]
                        }
                    }, () => self.getList());
                    setTimeout(function () {
                        self.setState({saveLoading: false});
                        window.location.href = self.props.paytrDomain + "/external/" + order.merchantOid;
                    }, 100);
                }).catch(function (error) {
                showAxiosError(error);
            }).then(function () {
                self.setState({saveLoading: false});
            });
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 3000,
                html: false
            });
            this.setState({saveLoading: false});
        }
    }

    onChange(e, index) {
        let payTrOrder = deepCopyObject(this.state.payTrOrder);
        let payTrOrderLines = deepCopyObject(payTrOrder.payTrOrderLines);
        if (e.name === "count") {
            let res = this.state.prices.find(price => price[0] === e.value && payTrOrderLines[index].unit === price[2]);
            payTrOrderLines[index]["count"] = e.value;
            payTrOrderLines[index]["price"] = res[1];
        } else if (e.name === "unit") {
            this.setState({value: e.value})

            if (e.value === 1) {
                payTrOrderLines[index]["unit"] = 1;
                payTrOrderLines[index]["count"] = this.state.initPrice[0];
                payTrOrderLines[index]["price"] = this.state.initPrice[1];
            } else if (e.value === 2) {
                payTrOrderLines[index]["unit"] = 2;
                payTrOrderLines[index]["count"] = this.state.initPriceMb[0];
                payTrOrderLines[index]["price"] = this.state.initPriceMb[1];
            }
        }
        payTrOrder.payTrOrderLines = payTrOrderLines;
        this.setState({payTrOrder});
    }

    getUnitExp(unit) {
        let exp = "";
        switch (unit) {
            case 1:
                exp = "Kontör(Adet)";
                break;
            case 2:
                exp = defterUnitName(EntegratorConf.identifier);
                break;
            case 3:
                exp = "e-Arşiv Kasa(Adet)";
                break;
            default:
                exp = "";
                break;
        }
        return exp;
    }

    getStatusColor(status) {
        let color = "";
        switch (status) {
            case 0:
                color = "#FF5733";
                break;
            case 1:
                color = "#101357";
                break;
            case 2:
                color = "#3d7c47";
                break;
            case 3:
                color = "#E5310A";
                break;
            default:
                color = "";
                break;
        }
        return color;
    }

    modifyDate(date) {
        return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }

    getStatusText(payTrOrder) {
        let result = "";
        let status = payTrOrder.status;
        switch (status) {
            case 0:
                result = <label style={{fontWeight: 'bold'}}><a
                    href={this.props.paytrDomain + "/external/" + payTrOrder.merchantOid}>{payTrOrder.explanation}</a></label>;
                break;
            case 1:
                result = <label style={{color: 'black', fontWeight: 'bold'}}>{payTrOrder.explanation}</label>;
                break;
            case 2:
                result = <label style={{color: '#3d7c47', fontWeight: 'bold'}}>{payTrOrder.explanation}</label>;
                break;
            case 3:
                result = <label style={{color: '#E5310A', fontWeight: 'bold'}}>{payTrOrder.explanation}</label>;
                break;
            default:
                result = <label style={{color: '#D6DBDF', fontWeight: 'bold'}}>{payTrOrder.explanation}</label>;
                break;
        }
        return result;
    }

    acceptCoupon() {
        if (VirtualHost.conf.resourcePrefix === "faturam24" && !this.state.acceptMbt24Coupon && this.state.couponCode && (this.state.couponCode === "MBT24" || this.state.couponCode === "mbt24")) {
            let payTrOrder = deepCopyObject(this.state.payTrOrder);
            let payTrOrderLines = [];
            payTrOrder.payTrOrderLines.map(p => {
                p.price = p.price - 24;
                payTrOrderLines.push(p);
            })
            payTrOrder.payTrOrderLines = payTrOrderLines;
            this.setState({payTrOrder: payTrOrder, couponCode: '', acceptMbt24Coupon: true});
        }
    }

    render() {
        let result = this.state.payTrOrder.payTrOrderLines.reduce(function (tot, arr) {
            return tot + arr.price;
        }, 0);
        result = new Decimal(new Decimal(result + result * 0.20).toFixed(2)).toNumber();
        const {isCreditUser, isAreaUser} = this.state
        let selectOptions = [];
        if (isCreditUser) {
            selectOptions.push({value: 1, label: "Kontör(Adet)"})
        }

        if (isAreaUser) {
            selectOptions.push({value: 2, label: defterUnitName(EntegratorConf.identifier)+"("+defterUnitNameShort(EntegratorConf.identifier)+")"});
        }

        return (
            <DefaultModal
                disabled={this.state.saveLoading}
                isOpen={this.props.show}
                title="Kontör Talep Takibi"
                size="lg"
                confirmBtnText=""
                cancelBtnText="Kapat"
                onConfirm={() => this.props.toggle(false)}
                onCancel={() => this.props.toggle(false)}>
                {this.state.loading ?
                    <ReactLoading type="spinningBubbles" style={{
                        width: "160px",
                        height: "160px",
                        margin: "20px auto 5px auto",
                        fill: "#888"
                    }}/>
                    :
                    <Col sm="12">
                        <Col sm="12" style={{border: "2px solid #e7e7e7", borderRadius: "6px 6px 6px 6px"}}>
                            <Row style={{marginBottom: "10px", marginTop: "6px"}}>
                                <Col sm="12" lg="11">
                                    {
                                        isCreditUser && <label style={{float: "left", margin: "1px 0px 0px 15px", fontWeight: "bold"}}>{"Kontör Geçerlilik Süresi: " + this.state.kontorYear + " yıl."}</label>
                                    }
                                    {
                                        isAreaUser && <label style={{float: "left", margin: "1px 0px 0px 15px", fontWeight: "bold"}}>{defterUnitName(EntegratorConf.identifier)+" Geçerlilik Süresi: " + this.state.alanYear + " yıl."}</label>
                                    }
                                </Col>
                                {VirtualHost.conf.resourcePrefix !== "faturam24" && <Col sm="12" lg="1">
                                    <button type="button" className="Btn ekle"
                                            style={{margin: "1", background: '#3fb0ac', float: 'right'}}
                                            onClick={() => this.addPayTrOrderLine()}>
                                    </button>
                                </Col>}
                            </Row>
                            <div className="card-body" style={{padding: '1em 1em 1em 1em'}}>
                                <div className="row">
                                    <div className="col-sm-12" style={{padding: '0'}}>
                                        <table className="" style={{textAlign: 'center'}}>
                                            <thead>
                                            <tr style={{backgroundColor: '#ebedf0'}}>
                                                <th width="2%">#</th>
                                                <th width="7%">Birim Türü</th>
                                                <th width="7%">Birim Miktarı</th>
                                                <th width="7%">Fiyat</th>
                                                <th width="3%">İşlemler</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.state.payTrOrder.payTrOrderLines.map((payTrOrderLine, index) =>
                                                <tr key={"payTrOrderLine1" + index}>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                        <Select
                                                            clearable={false}
                                                            placeholder="Birim Seçiniz.."
                                                            className="select-control"
                                                            value={payTrOrderLine.unit}
                                                            onChange={(e) => e && this.onChange({
                                                                name: "unit",
                                                                value: e.value
                                                            }, index)}
                                                            options={selectOptions}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Select id="count"
                                                                name="count"
                                                                value={payTrOrderLine.count}
                                                                clearable={false}
                                                                placeholder="Seçiniz..."
                                                                noResultsText="Kayıt bulunamadı."
                                                                onChange={(e) => this.onChange({
                                                                    name: "count",
                                                                    value: e.value
                                                                }, index)}
                                                                options={this.state.prices.filter(price => price[2] === payTrOrderLine.unit).map(price => ({
                                                                    value: price[0],
                                                                    label: (this.state.unlimited && price[0] === 100000) ? "Sınırsız" : price[0]
                                                                }))}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            id="price"
                                                            type="text"
                                                            data-vlength="1,255"
                                                            className="form-control"
                                                            disabled={true}
                                                            value={payTrOrderLine.price + " + " + (payTrOrderLine.price * 0.20) + " (%20) KDV"}
                                                            onChange={(e) => {
                                                            }}/>
                                                    </td>
                                                    <td>
                                                        {this.state.payTrOrder.payTrOrderLines.length > 1 &&
                                                        <button type="button" className="Btn temizle"
                                                                style={{margin: "0", background: '#FFCCCC'}}
                                                                onClick={() => this.removePayTrOrderLine(index)}>
                                                        </button>
                                                        }
                                                    </td>
                                                </tr>
                                            )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <Col sm="12">
                                        <p style={{float: "right"}}>Toplam Tutar: {result}₺</p>
                                    </Col>
                                    <Col sm="12">
                                        {VirtualHost.conf.resourcePrefix === "faturam24" && this.state.acceptMbt24Coupon &&
                                        <p style={{float: "right"}}>İndirim Kodu: mbt24</p>}
                                    </Col>
                                    <Col sm="12">
                                        {VirtualHost.conf.resourcePrefix === "faturam24" && this.state.acceptMbt24Coupon &&
                                        <p style={{float: "right"}}>İndirim Tutarı: 24₺</p>}
                                    </Col>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        {VirtualHost.conf.resourcePrefix === "faturam24" &&
                                        <div className="col-sm-12 coupon-container"
                                             style={{position: 'absolute', bottom: 0}}>
                                            <label className="mr-3">Kupon Kodu :</label>
                                            <input className="mr-3" type="text" placeholder="" style={{width: '200px'}}
                                                   value={this.state.couponCode}
                                                   onChange={(e) => this.setState({couponCode: e.target.value})}/>
                                            <button type="button"
                                                    style={{background: '#c2d4d8', marginRight: '0px'}}
                                                    disabled={this.state.saveLoading}
                                                    className="TekBtn kaydet"
                                                    onClick={this.acceptCoupon}>Kuponu Uygula
                                            </button>
                                        </div>}
                                        <button type="button"
                                                style={{
                                                    padding: '9px 39px 9px 13px',
                                                    float: 'right',
                                                    background: '#c2d4d8',
                                                    marginRight: '0px'
                                                }}
                                                disabled={this.state.saveLoading}
                                                className="col-sm-21 TekBtn"
                                                onClick={this.save}>Satın Al
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        {(this.state.payTrOrderList && this.state.payTrOrderList.length > 0) &&
                        <Col sm="12" style={{
                            paddingBottom: "10px",
                            marginTop: "10px",
                            border: "2px solid #e7e7e7",
                            borderRadius: "6px 6px 6px 6px"
                        }}>
                            <h6 style={{marginBottom: "10px", marginTop: "6px", textTransform: "none"}}>Ödeme Takibi(Ödeme soruları için RefNo paylaşınız.)</h6>
                            <div className="card-body" style={{padding: '1em 1em 1em 1em'}}>
                                <div className="row">
                                    <div className="col-sm-12" style={{padding: '0'}}>
                                        <table className="" style={{textAlign: 'center'}}>
                                            <thead>
                                            <tr style={{backgroundColor: '#ebedf0'}}>
                                                <th width="5%">#</th>
                                                <th width="20%">RefNo</th>
                                                <th width="15%">Miktar</th>
                                                <th width="40%">Durum</th>
                                                <th width="20%">Tarih</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.state.payTrOrderList.map((payTrOrder, index1) =>
                                            <Fragment key={"index1_" + index1 + "_" +payTrOrder.recordId}>
                                            {payTrOrder.payTrOrderLines.map((payTrOrderLine, index2) =>
                                                <tr key={"index2_" + index2 + "_" +payTrOrderLine.recordId}>
                                                    <td>{index1 + index2 + 1}</td>
                                                    <td>
                                                        {payTrOrder.merchantOid}
                                                        <p><CopyToClipboard text={payTrOrder.merchantOid} onCopy={() => this.copied(payTrOrder.merchantOid)}>
                                                            <button className="btn "
                                                                    style={{
                                                                        padding: "0px 9px 0px 9px",
                                                                        margin: "0px",
                                                                        backgroundColor: "inherit",
                                                                        color: "#78b1d7"
                                                                    }}>
                                                                <i className="far fa-copy"></i>
                                                            </button>
                                                        </CopyToClipboard>
                                                        </p>
                                                    </td>
                                                    <td>
                                                        <p style={{display:'inline'}}>{payTrOrderLine.count + " " + this.getUnitExp(payTrOrderLine.unit)}</p>
                                                    </td>
                                                    <td>
                                                        {this.getStatusText(payTrOrder)}
                                                    </td>
                                                    <td>
                                                        {payTrOrder.updatedAt ? this.modifyDate(payTrOrder.updatedAt) : this.modifyDate(payTrOrder.createdAt)}
                                                    </td>
                                                </tr>
                                            )}
                                            </Fragment>
                                            )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        }
                    </Col>
                }
            </DefaultModal>
        );
    }
}

export default PayTrModal;

